$(document).on("click", ".addreses_button", function () {
  $(this).parent().find(".edit-address-button").trigger("click");
});

let cartAutoCloseTimer = null;
function startCartAutoClose(drawer) {
    clearTimeout(cartAutoCloseTimer);
    cartAutoCloseTimer = setTimeout(() => {
        document.body.classList.remove('open-cc', 'open-cart');
        drawer?.classList.remove('active');
    }, 3500);
}
function stopCartAutoClose() {
    clearTimeout(cartAutoCloseTimer);
}
$(document).on('click', '.size-option-btn', function () {
    var vid = parseInt($(this).attr('data-variant-id'));
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            quantity: 1,
            id: vid
        },
        dataType: 'json',
        success: function (response) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            const drawer = document.querySelector('cart-drawer');
            document.body.classList.add('open-cc', 'open-cart');
            drawer?.classList.add('active');
            if (!drawer) return;
            drawer.dataset.userInteracted = 'false';
            startCartAutoClose(drawer);
            if (!drawer.dataset.autocloseBound) {
                const stopForever = () => {
                    if (drawer.dataset.userInteracted === 'false') {
                        drawer.dataset.userInteracted = 'true';
                        stopCartAutoClose();
                    }
                };
                drawer.addEventListener('touchstart', stopForever, { passive: true });
                drawer.addEventListener('touchmove', stopForever, { passive: true });
                drawer.addEventListener('scroll', stopForever, { passive: true });
                drawer.addEventListener('click', stopForever);
                drawer.addEventListener('mouseenter', stopForever);
                drawer.dataset.autocloseBound = 'true';
            }
        }
    });
});

$(document).on("click", ".side-panel-close-custom", function () {
  $("#side-panel-search-input").val("");
  $(".side-panel-content--has-tabs").removeClass("active");
});
$(document).on("click", ".custom_minus_button", function () {
  let removeButton = $(this).parent().parent().parent().find(".remove");

  if (removeButton.length) {
    removeButton[0].dispatchEvent(new Event("click", { bubbles: true }));
  }
});
setInterval(function () {
  const buttons = document.querySelectorAll(".single-add-to-cart-button--text");
  for (let i = 0; i < buttons.length; i++) {
    const button = buttons[i];
    const html = button.innerHTML.trim().toLowerCase();
    if (html === "sold out" || html === "coming soon") {
      button.parentNode.classList.add("soldout_button");
    } else {
      button.parentNode.classList.remove("soldout_button");
    }
  }
});
document.addEventListener("click", function (event) {
  if (event.target.closest(".iwish-row.iwishProduct-row")) {
    let productLink = event.target
      .closest(".iwish-row.iwishProduct-row")
      .querySelector(".product-title a");
    if (productLink) {
      productLink.click();
    }
  }
});

$(document).ready(function () {
  setTimeout(function () {
    $(".iwish-float-icon").trigger("click");
  }, 500);
  setTimeout(function () {
    var cartContent = $("body").find(".iwish-drawer-menu .drawer-body").html();
    $(".append_items_in").html(cartContent);
    console.log(cartContent);
    $(".iwish-row.iwish-prouctImg img").each(function () {
      var img = $(this);
      var src = img.attr("src");

      if (src.includes("x400")) {
        var newSrc = src.replace("x400", "x1024");
        img.attr("src", newSrc);
      }
    });
  }, 2500);
});

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const klarnaPlacement = document.querySelector("klarna-placement");

    if (klarnaPlacement && klarnaPlacement.shadowRoot) {
      const container = klarnaPlacement.shadowRoot.querySelector(".container.auto-size");

      if (container && !klarnaPlacement.classList.contains("styled")) {
        container.style.border = "unset";
        container.style.padding = "0px";
        container.style.textAlign = "left";

        const logo = container.querySelector(".logo");
        if (logo) {
          logo.style.fontSize = "13px";
        }

        klarnaPlacement.style.marginTop = "-7px";
        klarnaPlacement.style.display = "block";
        klarnaPlacement.classList.add("styled");

        const klarnaParent = klarnaPlacement.parentElement;
        if (klarnaParent && !klarnaParent.classList.contains("moved-klarna")) {
          const cloned = klarnaParent.cloneNode(true);
          cloned.classList.add("moved-klarna");
          klarnaParent.remove();

          const pickupAvailability = document.querySelector("pickup-availability");
          if (pickupAvailability) {
            pickupAvailability.parentNode.insertBefore(cloned, pickupAvailability);

            setTimeout(() => {
              const newKlarna = cloned.querySelector("klarna-placement");
              if (newKlarna && newKlarna.shadowRoot) {
                const newContainer = newKlarna.shadowRoot.querySelector(".container.auto-size");
                if (newContainer) {
                  newContainer.style.border = "unset";
                  newContainer.style.padding = "0px";
                  newContainer.style.textAlign = "left";

                  const newLogo = newContainer.querySelector(".logo");
                  if (newLogo) {
                    newLogo.style.fontSize = "13px";
                  }

                  newKlarna.style.marginTop = "-7px";
                  newKlarna.style.display = "block";
                }
              }
            }, 300); 
          }

          clearInterval(interval);
        }
      }
    }
  }, 300);
});



$(document).ready(function () {
  var item_product_title = $(".product-title-container h1").html();
  var item_product_color = $(
    ".variations .product-form__input--siblings label.active a"
  ).attr("title");
  var item_product_size = $(
    ".variations .product-form__input--block input[type=radio]:checked+label span"
  ).html();
  $(".item_product_title").html(item_product_title);
  $(".item_product_color").html(item_product_color);
  $(".item_product_size").html(item_product_size);
  $(".unavailable_pickup.custom_pickup_text").removeClass("custom_pickup_text");
  setTimeout(function(){
    $('.main_template #product_selected_or_first_available_variant_id').attr('value','');
    $('.main_size_selector_div input[checked]').removeAttr('checked');
    $('.product-information').addClass('variations_loaded');
  },600)
});
$(document).on("click", ".custom_pickup_button", function () {
  $(this).parent().find(".hidden_text").removeClass("hidden_text");
   $('body').find("#cookie_styles").remove();
});

$(document).on("click", ".actual_button", function () {
  $('body').find("#cookie_styles").remove();
});

$(document).on(
  'click',
  '.product-drawer .variations_loaded .variations .product-form__input--block input[type=radio]:not(.is-disabled)',
  function () {
      let label = $(this).next('label');
      setTimeout(function(){
        $(label).parent().parent().parent().parent().parent().parent().find('button.single-add-to-cart-button').removeAttr('disabled');
      },100)
      setTimeout(function(){
        $(label).parent().parent().parent().parent().parent().parent().find('button.single-add-to-cart-button').trigger('click');
          console.log('clicked')
      },400)
  }
);


function adjustHeaderPosition() {
  var $bar = $('#bmsm-stickyannouncementbar');
  var $header = $('.header-section');

  if ($bar.length) {
    var barHeight = $bar.outerHeight();
    $header.css('top', barHeight + 'px');
  } else {
    $header.css('top', '');
  }
}
$(window).on('load scroll resize', adjustHeaderPosition);
adjustHeaderPosition();



$(document).on('click','.pickup-notification-close',function(){
    $('.pickup_notification').hide()
})

document.addEventListener('DOMContentLoaded', function () {
  function checkApplePay() {
    const acceleratedCart = document.querySelector('shopify-accelerated-checkout-cart');
    if (!acceleratedCart) return;

    const applePayBtn = acceleratedCart.querySelector('shopify-apple-pay-button');
    const additionalButtons = document.querySelector('.additional-checkout-buttons');

    if (applePayBtn && additionalButtons) {
      additionalButtons.classList.add('apple-pay-full-width');
    }
  }

  checkApplePay();

  const observer = new MutationObserver(checkApplePay);
  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', function () {

  function checkApplePay() {
    const applePayBtn = document.querySelector('shopify-accelerated-checkout-cart shopify-apple-pay-button');
    const target = document.querySelector('.cart-items tfoot .thb-cart-form--cart-collaterals .additional-checkout-buttons');

    if (!target) return;

    if (!applePayBtn) {
      target.classList.add('no-apple-pay');
    } else {
      target.classList.remove('no-apple-pay');
    }
  }

  setTimeout(checkApplePay, 300);
  setTimeout(checkApplePay, 800);
  setTimeout(checkApplePay, 1500);

});



(function() {
    function initSizeSelector(container) {
        const productCards = container.querySelectorAll('product-card');
        
        productCards.forEach(card => {
            const sizeSelector = card.querySelector('.product-card-size-selector');
            if (!sizeSelector) return;
            
            if (sizeSelector.dataset.initialized === 'true') return;
            sizeSelector.dataset.initialized = 'true';
            
            const sizeList = sizeSelector.querySelector('.size-options-list');
            const prevBtn = sizeSelector.querySelector('.size-nav-prev');
            const nextBtn = sizeSelector.querySelector('.size-nav-next');
            const sizeBtns = sizeSelector.querySelectorAll('.size-option-btn');
            const totalSizes = sizeList ? parseInt(sizeList.dataset.totalSizes) || sizeBtns.length : sizeBtns.length;
            
            if (totalSizes > 4 && prevBtn && nextBtn && sizeList) {
                const scrollAmount = 200;
                
                const updateButtons = () => {
                    if (!sizeList) return;
                    const scrollLeft = sizeList.scrollLeft;
                    const maxScroll = sizeList.scrollWidth - sizeList.clientWidth;
                    prevBtn.disabled = scrollLeft <= 5;
                    nextBtn.disabled = maxScroll - scrollLeft <= 5;
                };
                
                const newPrevBtn = prevBtn.cloneNode(true);
                const newNextBtn = nextBtn.cloneNode(true);
                prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
                nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
                
                newPrevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    sizeList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                    setTimeout(updateButtons, 300);
                });
                
                newNextBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    sizeList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                    setTimeout(updateButtons, 300);
                });
                
                sizeList.addEventListener('scroll', updateButtons);
                updateButtons();
            } else if (prevBtn && nextBtn) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
            }
        });
    }
    
    function initializeAll() {
        initSizeSelector(document);
    }
    
    function setupMutationObserver() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            if (node.matches && node.matches('product-card')) {
                                initSizeSelector(node.parentNode);
                            } else if (node.querySelectorAll) {
                                const productCards = node.querySelectorAll('product-card');
                                if (productCards.length) {
                                    initSizeSelector(node);
                                }
                            }
                        }
                    });
                }
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        return observer;
    }
    
    function setupShopifyEvents() {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.detail && event.detail.section) {
                initSizeSelector(event.detail.section);
            }
        });
        
        document.addEventListener('shopify:block:select', (event) => {
            if (event.detail && event.detail.section) {
                initSizeSelector(event.detail.section);
            }
        });
        
        document.addEventListener('ajax:success', (event) => {
            initSizeSelector(document);
        });
        
        document.addEventListener('collection:updated', () => {
            initSizeSelector(document);
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initializeAll();
            setupMutationObserver();
            setupShopifyEvents();
        });
    } else {
        initializeAll();
        setupMutationObserver();
        setupShopifyEvents();
    }
    
    document.body.addEventListener('click', (e) => {
        const filterElement = e.target.closest('.filter-group, .filter, .facet-checkbox, .facet-link, .collection-filters button, [data-filter]');
        if (filterElement) {
            setTimeout(() => {
                initSizeSelector(document);
            }, 500);
        }
    });
})();

document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('view') === 'Size_Chart') {
        setTimeout(() => {
            const chartTrigger = document.querySelector('#ProductPopup-variant_picker');
            if (chartTrigger) {
                chartTrigger.click();
                urlParams.delete('view');
                const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
                window.history.replaceState(null, '', newUrl);
            }
        }, 100); 
    }
});